export const steps = [
  {
    title: 'product',
    content: 'First-content',
  },
  {
    title: 'product.extras',
    content: 'Second-content',
  },
  {
    title: 'stocks',
    content: 'Third-content',
  },
  {
    title: 'product.property',
    content: 'Fourth-content',
  },
  {
    title: 'finish',
    content: 'Finish-content',
  },
];
